// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./welcome-text-image.jpg");
var dir = previousRequest.replace("welcome-text-image.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "welcome-text-image.jpg",
	name: "welcome-text-image",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/welcome-text-image.jpg
// module id = 91
// module chunks = 4